import * as z from "zod";

export const getCheckoutExperienceHistory = {
  name: "getCheckoutExperienceHistory" as const,
  input: z.object({ checkoutExperienceId: z.string() }),
  output: z.array(
    z.object({
      eventId: z.string(),
      timestamp: z.date(),
      action: z.enum(["created", "updated", "deleted"]),
      intent: z.string().optional(),
      actorLabel: z.string(),
      actorKind: z.enum(["user", "redo", "ai", "system"]),
      changes: z.array(
        z.object({
          field: z.string(),
          before: z.string().nullable(),
          after: z.string().nullable(),
        }),
      ),
    }),
  ),
};
export type GetCheckoutExperienceHistoryOutput = z.infer<
  typeof getCheckoutExperienceHistory.output
>;
